import { useTranslation } from "react-i18next";
import BlankModal from "components/commons/BlankModal";
import Loading from "components/commons/Loading";
import { useEditContractModelMutation } from "../api/workContractApiSlice";
import ContractModelForm from "../views/ContractModelForm";

export default function EditContractModelModal({ data }) {

    const [t, i18n] = useTranslation("global", "absenceReport");

    // API
    const [createCompany, {
        data: createResult,
        isLoading: createIsLoading,
        isSuccess: createSuccess,
        reset: createReset
    }] = useEditContractModelMutation()

    let content

    if (createIsLoading) {
        content = <Loading />
    } else content = <>
        {
            createSuccess &&
            <div className="alert alert-success">
                Edited successfully!<br />
            </div>
        }
        <ContractModelForm initialData={createSuccess ? createResult : data} onSubmit={createCompany} />
    </>

    return (
        <BlankModal
            modalId={"modal-" + data.guid.substr(data.guid.length - 4)}
            title={t("absenceReport:menu.contract_edit")}
            buttonClass="btn-secondary"
            buttonLabel={
                <>
                    <i className="fa-solid fa-pen-to-square"></i> {t("action.edit")}
                </>
            }
            body={content}
        />
    );
}